<template>
    <div :style="style" class="input-color" :class="clas">
        <ColorPicker
            v-model:pure-color="color"
            format="hex6"
            disable-history
            style="display: none"
            :debounce="4"
            @pure-color-change="change"
        >
            <template #extra>
                <div class="vc-colorPicker__record">
                    <button
                        class="btn btn-outline-primary btn-block py-0"
                        @click="addFavourite"
                    >
                        <i class="fa fa-save"></i>
                        {{ t("new-general.add-favourites") }}
                    </button>
                    <div class="color-list row px-0 py-1 m-0">
                        <div
                            v-for="(_color, index) in favourites"
                            :key="index"
                            class="color-item transparent"
                            style="padding: 1px; position: relative"
                        >
                            <div
                                class="color-item__display row p-0 m-0 justify-content-center align-items-center"
                                role="button"
                                @click="
                                    () => {
                                        doAction(_color);
                                    }
                                "
                                style="
                                    border: 0.5px solid gray;
                                    border-radius: 3px;
                                "
                                :style="{
                                    backgroundColor: _color,
                                    width: '1.8rem',
                                    height: '1.8rem',
                                }"
                            >
                                <i
                                    v-if="removing"
                                    class="fa fa-times-circle text-danger"
                                    style="
                                        background-color: white;
                                        width: auto;
                                        height: auto;
                                        border-radius: 100%;
                                    "
                                ></i>
                            </div>
                        </div>
                    </div>
                    <button
                        v-if="favourites.length > 0"
                        class="btn btn-block py-0"
                        :class="{
                            'btn-danger': !removing,
                            'btn-success': removing,
                        }"
                        @click="() => (removing = !removing)"
                    >
                        <i
                            class="fa"
                            :class="{
                                'fa-trash': !removing,
                                'fa-check': removing,
                            }"
                        ></i>
                        {{
                            removing
                                ? t("new-general.select-favourites")
                                : t("new-general.remove-favourites")
                        }}
                    </button>
                </div>
            </template>
        </ColorPicker>
    </div>
</template>

<script>
import { ColorPicker } from "vue3-colorpicker";
import "vue3-colorpicker/style.css";
import { useColorStore } from "@/store/colorStore.js";
import { mapActions, mapState } from "pinia";
import { t } from "@/lang";

export default {
    name: "InputColor",
    components: {
        ColorPicker,
    },
    props: {
        pureColor: String,
        style: [String, Object],
        clas: [String, undefined],
    },
    emits: ["update:pure-color", "change"],
    computed: {
        color: {
            get() {
                return this.pureColor;
            },
            set(val) {
                this.$emit("update:pure-color", val);
            },
        },
        ...mapState(useColorStore, ["favourites"]),
    },
    data() {
        return {
            removing: false,
            activeKey: false,
        };
    },
    methods: {
        ...mapActions(useColorStore, ["add", "remove"]),
        t,
        addFavourite() {
            this.add(this.color);
        },
        doAction(color) {
            if (this.removing) {
                this.remove(color);
            } else {
                this.color = color;
            }
        },
        change() {
            this.$emit("change", this.color);
        },
    },
};
</script>
<style scoped lang="scss">
.input-color {
    border: 0.6px solid gray;
    position: relative;
    overflow: hidden;
    padding: 1.2px;
    border-radius: 2px;
    background-color: rgb(245, 243, 243);
    display: flex;
    justify-content: center;
    align-items: center;

    & > * {
        width: 100% !important;
        height: 100% !important;
        margin: 0px !important;
        border: 1px solid gray;
    }
}
</style>
